import { useState } from 'react';
import { faqItems } from '@/mocks/homeContent';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full py-20 md:py-28 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="font-mincho text-primary-600 tracking-widest text-sm md:text-base mb-3">
            FAQ
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 leading-snug">
            よくある<span className="text-primary-500">ご質問</span>
          </h2>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div
                key={idx}
                className="rounded-lg bg-background-100 border border-background-200 overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(isOpen ? null : idx)}
                  className="w-full flex items-center gap-4 p-5 md:p-6 text-left cursor-pointer hover:bg-background-200/50 transition-colors"
                >
                  <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-500 text-background-50 font-bold shrink-0 text-sm">
                    Q
                  </span>
                  <h4 className="flex-1 font-bold text-foreground-950 text-sm md:text-base">
                    {item.question}
                  </h4>
                  <span
                    className={`w-6 h-6 flex items-center justify-center text-foreground-700 transition-transform ${
                      isOpen ? 'rotate-180' : ''
                    }`}
                  >
                    <span className="w-6 h-6 flex items-center justify-center text-xl">
                      <i className="ri-arrow-down-s-line" />
                    </span>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 md:px-6 pb-5 md:pb-6 flex gap-4">
                    <span className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-700 text-background-50 font-bold shrink-0 text-sm">
                      A
                    </span>
                    <p className="flex-1 text-foreground-700 text-sm md:text-base leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}